import { render, staticRenderFns } from "./ReportBuilder.vue?vue&type=template&id=446872af&"
import script from "./ReportBuilder.vue?vue&type=script&lang=js&"
export * from "./ReportBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports